import { ArrowDown, ArrowUp } from "iconsax-react";
import type { JSX } from "react";

export interface StatCardProps {
  title: string; 
  value: string | number;
  icon: JSX.Element;
  trend?: {
    value: string;
    type: "increase" | "decrease" | "neutral";
  };
  subtitle?: string;
}

const StatCard = ({
  title,
  value,
  icon: Icon,
  trend,
  subtitle,
}: StatCardProps) => {
  const getTrendColor = () => {
    if (!trend) return "";
    switch (trend.type) {
      case "increase":
        return "text-[#3DD68C]";
      case "decrease":
        return "text-[#FF9592]";
      default:
        return "text-dark-100";
    }
  };

  const TrendIcon = () => {
    if (!trend) return null;

    switch (trend.type) {
      case "increase":
        return <ArrowUp color="#3DD68C" size={14} />;
      case "decrease":
        return <ArrowDown color="#FF9592" size={14} />;
      default:
        return "";
    }
  };

  return (
    <div className="flex flex-col justify-between bg-dark-10 rounded-[5px] p-4 hover:border-dark-50 transition-all duration-200 h-[118px] flex-1">
      <div className="flex items-center gap-1.5 text-dark-60">
        {Icon}
        <span className="text-sm font-medium">{title}</span>
      </div>

      <div className="flex items-center gap-2">
        <h3 className="text-2xl leading-[34px] font-bold text-dark-text">
          {value}
        </h3>
        {trend && (
          <div className={`flex items-center text-xsm ${getTrendColor()}`}>
            <TrendIcon />
            <span>{trend.value}</span>
          </div>
        )}
        {subtitle && <p className="text-sm text-dark-100 mt-1">{subtitle}</p>}
      </div>
    </div>
  );
};

export default StatCard;
